/* (c) Copyright Frontify Ltd., all rights reserved. */

import { type HTMLAttributes, createContext } from 'react';

export const ModalTitle = createContext<HTMLAttributes<HTMLElement>>({ id: undefined });
